module.exports = __webpack_public_path__ + "static/media/bgAdv1.e7042e0b.jpg";